import React__default from 'react';
import Columns from '../Columns/index.js';
import PostPreview from '../PostPreview/index.js';

var FeaturedPosts = function FeaturedPosts(_ref) {
  var posts = _ref.posts;
  if ((posts === null || posts === void 0 ? void 0 : posts.length) === 0) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Columns, null, (posts === null || posts === void 0 ? void 0 : posts.length) > 0 && (posts === null || posts === void 0 ? void 0 : posts.map(function (post) {
    var _post$author;
    return /*#__PURE__*/React__default.createElement(PostPreview, {
      stacked: true,
      image: post === null || post === void 0 ? void 0 : post.mappedThumbnail,
      featured: true,
      authorName: post === null || post === void 0 || (_post$author = post.author) === null || _post$author === void 0 ? void 0 : _post$author.fullName,
      date: post === null || post === void 0 ? void 0 : post.date,
      title: post === null || post === void 0 ? void 0 : post.title,
      link: post === null || post === void 0 ? void 0 : post.link
    });
  })));
};
var FeaturedPosts$1 = FeaturedPosts;

export { FeaturedPosts$1 as default };
//# sourceMappingURL=index.js.map
